var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3076 5.07693L5.07689 20.3077C4.69474 20.6899 4.07443 20.6899 3.69228 20.3077C3.31012 19.9255 3.31012 19.3052 3.69228 18.9231L18.923 3.69231C19.3052 3.31016 19.9255 3.31016 20.3076 3.69231C20.6898 4.07447 20.6898 4.69477 20.3076 5.07693Z",
    fill: "#1D2C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.923 20.3077L3.69224 5.07692C3.31009 4.69477 3.31009 4.07446 3.69224 3.69231C4.0744 3.31015 4.6947 3.31015 5.07686 3.69231L20.3076 18.9231C20.6898 19.3052 20.6898 19.9255 20.3076 20.3077C19.9254 20.6898 19.3051 20.6898 18.923 20.3077Z",
    fill: "#1D2C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dfd749b6.svg";
export { ForwardRef as ReactComponent };